module.exports = {"minStake":100,"maxStake":10000,"maxWinnings":200000,"stakeDivisor":1}


//////////////////
// WEBPACK FOOTER
// ./src/constants/configurations/betLimitsConfig.json
// module id = 663
// module chunks = 0